module.exports = __webpack_public_path__ + "static/media/box-number-gold.d59b5303.png";